/* AXORA · Tema Shopify · interacción */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* Menú móvil */
  var nav = $('.ax-nav');
  if (nav) {
    var btn = $('.ax-burger', nav);
    var close = function () { nav.classList.remove('ax-open'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-label', btn.getAttribute('data-t-open') || 'Menu'); document.body.style.overflow = ''; };
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('ax-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? (btn.getAttribute('data-t-close') || 'Close') : (btn.getAttribute('data-t-open') || 'Menu'));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('.ax-menu a', nav).forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('ax-open')) { close(); btn.focus(); } });
  }

  /* Cuenta atrás */
  $$('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) { el.style.display = 'none'; return; }
    var d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
    var two = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = Math.max(0, target - Date.now());
      var dd = Math.floor(diff / 86400000); diff -= dd * 86400000;
      var hh = Math.floor(diff / 3600000); diff -= hh * 3600000;
      var mm = Math.floor(diff / 60000); diff -= mm * 60000;
      d.textContent = two(dd); h.textContent = two(hh); m.textContent = two(mm); s.textContent = two(Math.floor(diff / 1000));
    };
    tick(); setInterval(tick, 1000);
  });

  /* Selector de talla → variante */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-variants]', root);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var btnText = JSON.parse(($('[data-button-text]', root) || {}).textContent || '"Add to cart"');
    var input = $('[data-variant-input]', root);
    var add = $('[data-add]', root), addText = $('[data-add-text]', root), price = $('[data-price]', root);
    var radios = $$('[data-option]', root);
    if (!radios.length) return;
    var money = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' €'; }
    };
    var update = function () {
      var sel = [];
      radios.forEach(function (r) { if (r.checked) sel[parseInt(r.getAttribute('data-option'), 10) - 1] = r.value; });
      sel.forEach(function (v, i) { var l = $('[data-opt-label="' + (i + 1) + '"]', root); if (l) l.textContent = v; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) { add.disabled = true; addText.textContent = root.getAttribute('data-t-unavailable') || 'Unavailable'; return; }
      input.value = v.id;
      add.disabled = !v.available;
      addText.textContent = v.available ? btnText : (root.getAttribute('data-t-soldout') || 'Sold out');
      if (price) price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + money(v.price);
      if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    };
    /* Marca las tallas sin stock (para productos de una sola opción) */
    if (variants[0] && variants[0].options.length === 1) {
      radios.forEach(function (r) {
        var v = variants.filter(function (x) { return x.options[0] === r.value; })[0];
        if (v && !v.available) r.closest('.ax-pill').classList.add('ax-na');
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
  });

  /* Lookbook: arrastrar con el ratón */
  $$('[data-drag]').forEach(function (s) {
    var down = false, sx = 0, sl = 0;
    s.addEventListener('mousedown', function (e) { down = true; s.classList.add('ax-drag'); sx = e.pageX; sl = s.scrollLeft; });
    window.addEventListener('mouseup', function () { down = false; s.classList.remove('ax-drag'); });
    s.addEventListener('mousemove', function (e) { if (!down) return; e.preventDefault(); s.scrollLeft = sl - (e.pageX - sx) * 1.4; });
  });

  if (reduce || designMode) return;

  /* Aparición suave de abajo a arriba */
  if ('IntersectionObserver' in window) {
    var items = $$('.ax-section .ax-wrap > *, .ax-card, .ax-look, .ax-hero__img, .ax-product__media').filter(function (el) { return !el.closest('.ax-header'); });
    document.documentElement.classList.add('ax-js');
    items.forEach(function (el) { el.classList.add('ax-r'); });
    var show = function (el) {
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.transitionDelay = (Math.min(i, 5) * 0.1) + 's';
      el.classList.add('ax-in');
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
    requestAnimationFrame(function () { items.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 0.85) { show(el); io.unobserve(el); } }); });
    setTimeout(function () { items.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('ax-in'); }); }, 3000);
  }

  /* Punto rojo como cursor */
  var c = document.getElementById('ax-cursor');
  if (c && window.matchMedia('(pointer: fine)').matches) {
    var x = -100, y = -100, cx = -100, cy = -100;
    window.addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; c.classList.add('ax-on'); });
    document.addEventListener('mouseleave', function () { c.classList.remove('ax-on'); });
    document.addEventListener('mouseover', function (e) { c.classList.toggle('ax-link', !!e.target.closest('a, button, label.ax-pill, summary')); });
    (function loop() { cx += (x - cx) * 0.18; cy += (y - cy) * 0.18; c.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)'; requestAnimationFrame(loop); })();
  }
})();